import { useGetExperiencesList } from "@src/api/experiences-list/get-experiences-list";
import {
  POST_PURCHASE_DRAFT_ORG_IDS,
  shouldShowPostPurchaseDraftBadge,
} from "@src/components/Navigation/BaseSideNav/post-purchase-draft-badge";

export const usePostPurchaseDraftBadge = (orgId: string | undefined) => {
  const isListed = !!orgId && POST_PURCHASE_DRAFT_ORG_IDS.has(orgId);
  // Same query as the Post-purchase page, so they share a cache. Orgs off the
  // list never send it.
  const { data } = useGetExperiencesList({
    module: "postPurchase",
    fetchAllPages: true,
    enabled: isListed,
  });

  return (
    isListed && !!data && shouldShowPostPurchaseDraftBadge(data.experiencesList)
  );
};
